import { css } from "@emotion/react";

import { NeutralTxtDefault, CanvasDefault, HighlightStrongBorderStrong, PrimaryTxtDefault, PrimaryBgWeakHover, PrimaryTxtInvDefault, NeutralTxtStrongDefault, NeutralBgDefault, NeutralBorderDefault, NeutralTxtWeakDefault, HighlightLimeBorderStrong } from "../../tokens/js/dark";
import { globalStyles } from "./global-styles";
import { pxToRem } from "./css-utils";
import { Lime1000, Lime600 } from "../../tokens/js/colors";

export const focusStylesDark = css`
  outline: ${pxToRem(2)} solid ${HighlightStrongBorderStrong};
  outline-offset: ${pxToRem(2)};
`;

export const linkStylesDark = css`
  color: ${PrimaryTxtDefault};
  background-image: linear-gradient(to bottom, transparent 0%, transparent 0%),
    linear-gradient(
      to right,
      ${PrimaryBgWeakHover} 33%,
      transparent 33%,
      transparent 66%,
      transparent 66%
    );

  &:focus-visible {
    ${focusStylesDark};
  }

  &:hover,
  &:active,
  &:focus {
    color: ${PrimaryTxtInvDefault};
  }
`;

export const codeStylesDark = css`
  background: ${NeutralBgDefault};
`;

export const inputStylesDark = css`
  border: ${pxToRem(2)} solid ${NeutralBorderDefault};
  background: ${NeutralBgDefault};

  color: ${NeutralTxtDefault};

  &::placeholder {
    color: ${NeutralTxtWeakDefault};
  }

  &:focus {
    outline: ${pxToRem(2)} solid ${HighlightLimeBorderStrong};
  }
`;

export const numbersLimeDark = css`
  li::before {
    background: ${Lime1000};
    color: ${Lime600};
  }
`;

export const checkmarksLimeDark = css`
  li::before {
    background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Ccircle%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%20fill%3D%22%232B3200%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M17.07%208.63137L15.9386%207.5L10.31%2013.1286L7.88137%2010.7L6.75%2011.8314L10.2976%2015.379L10.5385%2015.1381L10.5508%2015.1505L17.07%208.63137Z%22%20fill%3D%22%23D5F800%22%2F%3E%0A%3C%2Fsvg%3E");
  }
`;

export const globalStylesDark = css`
  ${globalStyles}

  body {
    color: ${NeutralTxtDefault};
    background: ${CanvasDefault};
  }

  code {
    ${codeStylesDark};
    color: ${NeutralTxtStrongDefault};
  }

  pre {
    ${codeStylesDark};
  }

  input, textarea, select {
    ${inputStylesDark};
  }

  label {
    color: ${NeutralTxtDefault};
  }

  select {
    background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2225%22%20viewBox%3D%220%200%2024%2025%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.90002%2010.5371C6.90002%2010.2371%207.00002%2010.0371%207.20002%209.83711C7.60002%209.43711%208.20002%209.43711%208.60002%209.83711L12.1%2013.3371L15.6%209.83711C16%209.43711%2016.6%209.43711%2017%209.83711C17.4%2010.2371%2017.4%2010.8371%2017%2011.2371L12.8%2015.4371C12.4%2015.8371%2011.8%2015.8371%2011.4%2015.4371L7.20002%2011.2371C7.00002%2011.0371%206.90002%2010.8371%206.90002%2010.5371Z%22%20fill%3D%22%23B4BABD%22%2F%3E%0A%3C%2Fsvg%3E%0A");
    background-repeat: no-repeat;
    background-position: calc(100% - 10px);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${NeutralTxtStrongDefault}
  }

  a:not([class]) {
    ${linkStylesDark}
  }
`;